module.exports = __webpack_public_path__ + "img/798-d19d59.png";